<template>
	<div class="how-it-works">
		<!-- BIG SLOGAN -->
		<div class="container">
			<h1 class="big-slogan-blue">{{ $t("howItWorks.pageHeader") }}</h1>
			<h2 class="mb-50">
				<sub>
					<span class="logo-font domore-yellow">do</span>
					<span class="logo-font domore-blue-1">MORE</span>
				</sub>
				{{ $t("howItWorks.sloganTop") }}
			</h2>
		</div><!-- .container -->

		<!-- PRICING OPTIONS-->
		<div class="container-fluid pricing-options domore-blue-1-bgd">
			<div class="row">
				<div class="col-md-12">
					<h2 class="text-center mt-50 mb-30 white">{{ $t("crowdfundingOptions.title") }}</h2>
				</div><!-- .col-md-12 -->
			</div><!-- .row -->
			<div class="row">
				<div class="col-md-4 col-md-offset-2">
					<h3 class="text-center mb-50">
						{{ $t("crowdfundingOptions.optionOneTitle") }}
						</br>
						<small class="white">{{ $t("crowdfundingOptions.optionOneDescription") }}</small>
					</h3>
				</div><!-- .col-md-4 -->
				<div class="col-md-4">
					<h3 class="text-center mb-50">
						{{ $t("crowdfundingOptions.optionTwoTitle") }}
						</br>
						<small class="white">{{ $t("crowdfundingOptions.optionTwoDescription") }}</small>
					</h3>
				</div><!-- .col-md-4 -->
			</div><!-- .row -->
		</div><!-- .container -->

		<!-- PAYMENTS-->
		<div class="container payments">
			<div class="row">
				<div class="col-md-12">
					<h2 class="text-center mt-50 mb-30">{{ $t("pricing.title") }}</h2>
				</div><!-- .col-md-12 -->
			</div><!-- .row -->
			<div class="row">
				<div class="col-md-4">
					<h5 class="text-center mb-50"><i class="fa fa-star" aria-hidden="true"></i></br>{{ $t("pricing.paymentOne") }}</h5>
				</div><!-- .col-md-4 -->
				<div class="col-md-4">
					<h5 class="text-center mb-50"><i class="fa fa-star" aria-hidden="true"></i></br>{{ $t("pricing.paymentTwo") }}</h5>
				</div><!-- .col-md-4 -->
				<div class="col-md-4">
					<h5 class="text-center mb-50"><i class="fa fa-star" aria-hidden="true"></i></br>{{ $t("pricing.currencies") }}</h5>
				</div><!-- .col-md-4 -->
			</div><!-- .row -->
			<div class="row">
				<div class="col-md-4 col-md-offset-2">
					<div class="jumbotron price-crow domore-blue-1-light-bgd">
						<h4 class="crowd-or-rais"><span class="domore-blue-1">CROWDFUNDING</span></h4>
						<h3 class="text-center">
							5%</br>
							<small>{{ $t("pricing.platformFees") }}</small>
						</h3>
					</div>
				</div><!-- .col-md-4 -->
				<div class="col-md-4">
					<div class="jumbotron price-rais domore-yellow-light-bgd">
						<h4 class="crowd-or-rais"><span class="domore-yellow">FUNDRAISING</span></h4>
						<h3 class="text-center">
							0%</br>
							<small>{{ $t("pricing.platformFees") }}</small>
						</h3>
					</div>
				</div><!-- .col-md-4 -->
			</div><!-- .row -->
			<router-link to="/start_campaign" type="button" class="btn btn-default btn-lg button-center-crowd mb-50">
				{{ $t("howItWorks.startCampaignButton") }}
			</router-link>
		</div><!-- .container -->

		<why-do-more></why-do-more>
    <crowd-or-rais></crowd-or-rais>
	</div>
</template>

<script>
import WhyDoMore from '@/components/WhyDoMore';
import CrowdOrRais from '@/components/CrowdOrRais';

export default {
  components: { WhyDoMore, CrowdOrRais },
};
</script>



// WEBPACK FOOTER //
// HowItWorks.vue?cf1eccc6